export { FAQ_BIKE_DATA } from './accordion-bike-data';
export { FAQ_CAR_DATA } from './accordion-car-data';
export type { FAQItem } from './accordion-data.types';
export { default as Accordion } from './accordion.component';
export { default as AccordionList } from './accordionList.component';

